import ICON_MORE_V4_LIGHT from '../../../public/static/v4/common/icon-more-light.svg';
import ICON_MORE_V4 from '../../../public/static/v4/common/icon-more.svg';
import ICON_SEPARATOR_LIGHT from '../../../public/static/v4/common/icon-separator-light.svg';
import ICON_SEPARATOR from '../../../public/static/v4/common/icon-separator.svg';
import Anchor from '../../common/component/Anchor';
import PageImage from '../../common/component/PageImage';
import SingleText from '../../common/component/SingleText';
import Text from '../../common/component/Text';
import useTheme from '../../common/hook/useTheme';

interface IProps {
  title: string;
  subTextFirst?: string;
  subTextSecond?: string;
  thumbnail: string;
  isOnlyWhiteBg?: boolean;
  className?: string;
  onClick: () => void;
}

export default function EpisodeButtonV4({
  title,
  subTextFirst,
  subTextSecond,
  thumbnail,
  isOnlyWhiteBg = false,
  className,
  onClick,
}: IProps) {
  const {isLightMode} = useTheme();
  const isWhiteBg = isOnlyWhiteBg || isLightMode;
  return (
    <Anchor
      className={cn('rounded-12 items-center', className, {
        'bg-white': isWhiteBg,
        'bg-grey-01': !isLightMode,
      })}
      display="flex"
      onClick={onClick}
    >
      <PageImage
        src={thumbnail}
        alt={title}
        className="w-90 h-54 rounded-6"
        pictureClassName={cn(
          'relative',
          'after:absolute after:inset-0 after:rounded-6',
          'after:border after:border-solid after:border-black/15'
        )}
      />
      <div className="ml-14 mr-16 overflow-hidden">
        <SingleText
          className={cn(
            isOnlyWhiteBg ? 's13-medium-darkGrey01' : 's13-medium-grey15'
          )}
        >
          {title}
        </SingleText>
        <div className="flex items-center mt-4">
          {subTextFirst && (
            <Text
              className={cn(
                isOnlyWhiteBg ? 's12-regular-darkGrey07' : 's12-medium-grey07'
              )}
            >
              {subTextFirst}
            </Text>
          )}
          {subTextFirst && subTextSecond && (
            <>
              <img
                src={isWhiteBg ? ICON_SEPARATOR_LIGHT : ICON_SEPARATOR}
                alt=""
                width={10}
                height={10}
              />
              <Text
                className={cn(
                  isOnlyWhiteBg ? 's12-regular-darkGrey07' : 's12-medium-grey07'
                )}
              >
                {subTextSecond}
              </Text>
            </>
          )}
        </div>
      </div>
      <img
        src={isWhiteBg ? ICON_MORE_V4_LIGHT : ICON_MORE_V4}
        className="w-24 h-24 ml-auto"
        alt=""
      />
    </Anchor>
  );
}
